import { ActivityFormController, FormMode } from "PFApp/activities/activity_form";
import { CompareController } from "PFApp/activities/compare/compare_controller";
import { ApplyEngagementBlueprintPageController } from "PFApp/activities/engagement_blueprint/apply_engagement_blueprint_page_controller";
import { useManageRolesFeatureFlag } from "PFApp/activities/manage_roles/hooks/use_manage_roles_feature_flag";
import { ManageRolesPageController } from "PFApp/activities/manage_roles/manage_roles_page_controller";
import { ScenarioShowController } from "PFApp/activities/scenario";
import { ActivityShowController } from "PFApp/activities/show/activity_show_controller";
import NotFoundRoute from "PFApp/routes/not_found_route";
import {
  EnsureFeatureEnabled,
  EnsureLoggedInAndRegistered,
  EnsureProfilePermission,
  WithLayout
} from "PFApp/routes/route_helpers";
import { FeatureFlag, PermissionRule } from "PFTypes";
import { ReactNode } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router";

// TEMPORARY: ManageRolesRouteGuard will be removed once the manage roles feature is fully released.
const ManageRolesRouteGuard = ({ children }: { children: ReactNode }) => {
  const isManageRolesEnabled = useManageRolesFeatureFlag();

  if (!isManageRolesEnabled) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

const ActivitiesRoutes = () => {
  const location = useLocation();

  return (
    <EnsureLoggedInAndRegistered>
      <WithLayout>
        <Routes>
          <Route
            path=":templateType/new"
            element={<ActivityFormController mode={FormMode.New} key={location.key} />}
          />
          <Route
            path=":templateType/new/:id"
            element={<ActivityFormController mode={FormMode.Clone} key={location.key} />}
          />
          <Route path=":id/compare/:tab" element={<CompareController />} />
          <Route path=":id/compare/:tab/:ids" element={<CompareController />} />
          <Route path=":id/compare/:tab/:ids/:type" element={<CompareController />} />
          <Route path=":id/economics/:scenarioId" element={<ScenarioShowController />} />
          <Route
            path=":id/engagement_blueprint/:engagementBlueprintId"
            element={
              <EnsureFeatureEnabled feature={FeatureFlag.EngagementBlueprints}>
                <ApplyEngagementBlueprintPageController />
              </EnsureFeatureEnabled>
            }
          />
          <Route path=":id" element={<ActivityShowController />} />
          <Route
            path=":id/edit"
            element={<ActivityFormController mode={FormMode.Edit} key={location.key} />}
          />
          <Route path=":id/:section" element={<ActivityShowController />} />
          <Route path=":id/:section/:params" element={<ActivityShowController />} />
          <Route path=":templateType/conversation/:conversationId" element={<ActivityShowController />} />
          <Route
            path="manage_roles"
            element={
              <ManageRolesRouteGuard>
                <EnsureProfilePermission permittedTo={PermissionRule.BulkManageRoles}>
                  <ManageRolesPageController />
                </EnsureProfilePermission>
              </ManageRolesRouteGuard>
            }
          />
          <Route path="*" element={<NotFoundRoute />} />
        </Routes>
      </WithLayout>
    </EnsureLoggedInAndRegistered>
  );
};

export default ActivitiesRoutes;
